<div class="is-flex is-fullheight is-align-items-center is-justify-center">
  <img [ngSrc]="rainIcon()" width="55" height="63">
</div>